import {ChangeDetectionStrategy, Component} from '@angular/core';
import {SynchronizationFacadeService} from './synchronization-facade.service';
import {SynchronizationConfiguration} from './synchronization.reducer';

@Component({
  selector: 'app-synchronization',
  template: `
      <div class="sync-title-body-wrapper">
          <h4>{{title}}</h4>
      </div>
      <div class="wrapper">
          <div class="sync-body">
              <div class="sync-body-dropdown-button">
                  <app-synchronization-configuration-dropdown
                          (configurationSelectionChanged)="onConfigChange($event)"></app-synchronization-configuration-dropdown>
                  <button mat-raised-button
                          class="sync-button"
                          [disabled]="!selectedConfig"
                          (click)="scheduleSync()">Schedule synchronization
                  </button>
              </div>
              <app-synchronization-task-history
                      [selectedConfiguration]="selectedConfig"></app-synchronization-task-history>
          </div>
          <app-synchronization-configuration-create></app-synchronization-configuration-create>
      </div>
  `,
  styleUrls: ['./synchronization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SynchronizationComponent {
  selectedConfig?: SynchronizationConfiguration;
  title = `Select one platform configuration and click Schedule synchronization button to schedule a synchronization.
  Synchronization happens asynchronously so you will need to wait a couple of minutes for it to finish, 
  and refresh your page after that time.
 During the synchronization, DMP will perform a check, whether all entities in chosen platform are within 
 DMP and have shares configured with this platform. 
 When you select a configuration, synchronization tasks history will be displayed underneath.
 `;

  constructor(private facade: SynchronizationFacadeService) {
  }

  scheduleSync() {
    if (this.selectedConfig) {
      this.facade.scheduleSynchronisation(this.selectedConfig.id);
    }
  }

  onConfigChange($event: SynchronizationConfiguration) {
    this.selectedConfig = $event;
  }
}
